const PROXY_ORIGIN = 'http://localhost:8080';

export const isProxyUrl = (url: string) => {
  const origin = new URL(url).origin;

  return origin === PROXY_ORIGIN;
};
